import { getUserInfo } from "@/api/loginApi.js"
import { getRouter, userPermsApi } from "@/api/common.js"

var routerData = [];
function loopRouter (data) {
  data.forEach(val => {
    if (val.children && val.children.length > 0) {
      loopRouter(val.children)
    } else {
      routerData.push({
        path: val.path,
        name: val.name,
        icon: val.icon,
        component: (resolve) => require([`@/views${val.component}.vue`], resolve)
      })
    }
  })
  return routerData
}

const permission = {
  state: {
    addRouter: [],
    navMenu: [],
    perms: [],
    readPrivacyPolicy: false
  },

  mutations: {
    SET_ADDROUTER: (state, addRouter) => {
      state.addRouter = addRouter
    },
    SET_NAVMENU: (state, navMenu) => {
      state.navMenu = navMenu
    },
    SET_PERMS: (state, perms) => {
      state.perms = perms
    },
    SET_READ_PRIVACE_POLICY: (state, val) => {
      state.readPrivacyPolicy = val
    }
  },

  actions: {
    getAddRouterData ({ commit }, data) {
      return new Promise(resolve => {
        getUserInfo().then(res => {
          commit('SET_USERINFO', res.rows)
        })

        getRouter().then(res => {
          // res.rows.push({
          //   children: [],
          //   component: "/personalCenter/index",
          //   id: "",
          //   name: "Personal Center",
          //   parentId: "0",
          //   path: 'personalCenter',
          // })
          let routerData = loopRouter(res.rows)
          commit('SET_ADDROUTER', routerData)
          commit('SET_NAVMENU', res.rows)
          resolve()
        })

        userPermsApi().then(res => {
          commit('SET_PERMS', res.rows)
        })
      })
    }
  }
}

export default permission